import React, { forwardRef } from "react";
import SelectOption from "../../../../../../components/SelectOption";
import { useApi } from "../../../../../../hooks/http2";
import { URL_API, _ } from "../../../../../../utils";

const SelectTaste = (props) => {
  const list = useApi(
    {
      url: `${URL_API}/setting/master/product-taste`,
      token: true,
    },
    []
  );

  return (
    <SelectOption
      loading={list.loading}
      data={_.map(list.fetch?.data || [], (n) => ({
        value: n.id?.toString(),
        text: `${n.name_local} - ${n.name_en}`,
      }))}
      withAll
      allText={
        (list.fetch?.data || []).length > 0
          ? "เลือกรสชาติ"
          : "-- ไม่มีข้อมูล --"
      }
      {...props}
    />
  );
};

export default forwardRef((props, ref) => {
  return <SelectTaste forwardRef={ref} {...props} />;
});
